
import { Injectable, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { tap, switchMap, map } from 'rxjs/operators';
import { sotrageKeys } from './storageKeys';
import { de } from 'date-fns/locale';
import { forkJoin } from 'rxjs';
import { MM_I18N_CONFIG_TOKEN } from './i18n-config-token';
import { MmI18nConfig } from './i18n-config';

@Injectable({ providedIn: 'root' })
export class MmTranslateService {
    constructor(private translateService: TranslateService, @Inject(MM_I18N_CONFIG_TOKEN) private config: MmI18nConfig) {


    }

    init() {

        var lang = localStorage.getItem(sotrageKeys.lang) || this.translateService.defaultLang;
        return this.use(lang).toPromise();
    }

    use(lang: string) {
        return this.translateService.use(lang).pipe(
            tap(() => {

                localStorage.setItem(sotrageKeys.lang, lang)
            })
        )
    }

    get(key: string | string[]) {
        return this.translateService.get(key);
    }

    format(key: string, ...paramKeys: string[]) {
        return this.translateService.get(key).pipe(
            switchMap((f: string) => forkJoin(paramKeys.map(k => this.translateService.get(k))).pipe(
                map(([...params]) => {



                    if (!f) return f;
                    let i = 0;

                    Object.keys(params).forEach(key => {

                        const element = params[key];

                        f = f.replace(`{${i++}}`, element)



                    })
                    // let str = f;
                    // for (let index = 0; index < params.length; index++) {
                    //     debugger;
                    //     const element = params[index];
                    //     f = f.replace(`{${index}}`, element)
                    // }
                    return f;
                })
            ))

        )

    }

    get currentLang() {
        return this.translateService.currentLang || localStorage.getItem(sotrageKeys.lang) || this.translateService.defaultLang
    }


    get defaultLang() {
        return this.translateService.defaultLang;
    }

    get supportedLangs() {
        return [this.translateService.currentLang, ...this.config.supportedLangs.filter(f => f != this.translateService.currentLang)]
        // return this.config.supportedLangs;
    }



}